/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-fragments */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable react/button-has-type */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import * as XLSX from 'xlsx';
 import "primereact/resources/themes/lara-light-indigo/theme.css";
// import "primereact/resources/themes/lara-dark-blue/theme.css";
import "primereact/resources/primereact.css";
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import "primeflex/primeflex.css";
// import "./ReportTable.module.css";
import clsx from 'clsx';
import styles from './ReportTable.module.css';
// import { fontSize } from '@mui/system';

const ReportTable = ({ columns, data, height, fileName }) => {
  const [globalFilter, setGlobalFilter] = useState('');
  const [columnFilters, setColumnFilters] = useState({});
  const [filters, setFilters] = useState(null);
  const [filterData, setFilterData] = useState([]);
  const tableRef = useRef();

  console.log("window.screen.height: ", window.screen.height);
  const handTableScroll = e => {
    tableRef.current.scrollLeft = e.target.scrollLeft;
  };

  useEffect(() => {
    // Function to call when the DataTable component loads
    function onLoadFunction() {
      const extractedData = tableRef.current?.getVirtualScroller().props.items;
      setFilterData(extractedData);
    }
    // Call the function when the component mounts
    onLoadFunction();

  }, [filters]); 

  useEffect(() => {
    // console.log(primaryAction,"prps",rowsData);
    // eslint-disable-next-line prefer-destructuring
    tableRef.current = document.getElementsByClassName(
      'p-datatable-wrapper',
    )[0];

    if (tableRef.current)
      tableRef.current.addEventListener('scroll', handTableScroll);
  }, []);

  // useEffect(() => {
  //   // console.log("tableref",tableRef.current);
  //   console.log("getVirtual",tableRef.current?.getVirtualScroller().props.items);
  // }, [filters]);

  const initFilters = () => {
    const initialFilters = {global: { value: null, matchMode: FilterMatchMode.CONTAINS }};
    columns.forEach((column) => { 
      // initialFilters[column.field] = {
      //   operator: FilterOperator.AND,
      //   constraints: [{ valuse: null, matchMode: FilterMatchMode.STARTS_WITH }]
      // };
      initialFilters[column.field] ={ value: null, matchMode: FilterMatchMode.IN };
    });
    setFilters(initialFilters);
  };
  useEffect(() => {
    // Reset column filters and initialize filters when columns change
    setColumnFilters({});
    initFilters();
  }, [columns]);

  const clearFilter = () => {
    initFilters();
  };

  const renderHeader = () => (
    <Grid container spacing={2} direction="row" justifyContent="space-between">
      <Grid item md={3} lg={3} sm={8} xs={8}>
        <Button type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} className={styles.clearBtn} />
        <Button type="button" icon="pi pi-file-excel" label="Export To Excel" severity="success" onClick={exportToExcel} className={styles.clearBtn} />
      </Grid>
      <Grid item md={3} lg={3} sm={4} xs={4}>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText value={globalFilter} onChange={onGlobalFilterChange} placeholder="Keyword Search" className={styles.searchBtn} />
        </span>
      </Grid>
    </Grid>

      //     <div className="grid" style={{ margin: '-10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      //       <div className="col-fixed" style={{ display: 'flex', alignItems: 'center' }}>
      //         <Button type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} className={styles.clearBtn} />
      //         <Button type="button" icon="pi pi-file-excel" label="Export To Excel" severity="success" onClick={exportToExcel} className={styles.clearBtn} />
      //       </div>
      //       <div style={{ display: 'flex', alignItems: 'center' }}>
      //         <span className="p-input-icon-left">
      //           <i className="pi pi-search" />
      //           <InputText value={globalFilter} onChange={onGlobalFilterChange} placeholder="Keyword Search" style={{ fontSize: '12px', margin: '3px' }} />
      //         </span>
      //       </div>
      // </div>
    );

  const onGlobalFilterChange = (e) => {
    const {value} = e.target;
    const _filters = { ...filters };

    _filters.global.value = value;

    setFilters(_filters);
    setGlobalFilter(value);
};

  const onColumnFilterChange = (title, selectedValues) => {
    setColumnFilters((prevFilters) => ({
      ...prevFilters,
      [title]: selectedValues,
    }));

    setFilters((prevFilters) => ({
      ...prevFilters,
      [title]: {
        operator: FilterOperator.AND,
        constraints: [{ value: selectedValues, matchMode: FilterMatchMode.EQUALS }]
      },
    }));
  };

  const representativesItemTemplate = (option, field) => 
    // console.log(field, option)
    (
        <div className="flex align-items-center gap-2">
            <span style={{fontSize:'12px'}}>{option[field]}</span>
        </div>
    );

  const customFilterMenu = (options, title, field) => {

    const uniqueValues = Array.from(new Set(data.map(item => item[field])));
    const sortedArray = [...uniqueValues].sort();
      // Create options array dynamically
      const dynamicOptions = sortedArray.map(value => ({
        [field]: value,
        value,
      }));
      
        return (
          <React.Fragment>
            <MultiSelect
                filter
                value={options.value}
                options={dynamicOptions}
                display="chip"
                itemTemplate={(e)=>representativesItemTemplate(e, field)}
                onChange={(e) => options.filterApplyCallback(e.value)}
                // optionLabel="label"
                optionLabel={field}
                optionValue="value"
                // placeholder="Any"
                className="p-column-filter p-inputtext-sm"
                // className="p-inputtext-sm"
                maxSelectedLabels={1}
                style={{ minWidth: '10rem', fontSize:'12px' }}
            />
          </React.Fragment>
      );
  
  };

  const exportToExcel = () => {
    const extractedData = tableRef.current?.getVirtualScroller().props.items;
    // const exportData = Object.keys(columnFilters).length > 0
    //   ? extractedData.filter(item => Object.entries(columnFilters).every(([key, values]) => key!== 'id' && values.includes(item[key])))
    //   : extractedData;
    console.log("Mapped Data: ", extractedData);
    const headers = columns.map(column => column.title);
    const exportData = extractedData.map(item => {
      const {id, ...rest} = item;
      const reorderedItem = {};
      columns.forEach(mapping => {
          reorderedItem[mapping.title] = rest[mapping.field];
      });
      return reorderedItem;
    })
    console.log("Exported Data: ", extractedData);
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `${fileName}.csv`);
  };

  const dynamicColumns = columns.map((column) => (
    <Column
      key={column.field}
      headerStyle={{width : column.width}}
      field={column.field}
      // header={column.title}
      header= {
        <div style={{ paddingLeft: '0px', whiteSpace: 'normal' }}>
          {column.title}
        </div>
      }
      body={(rowData) => (
        <div className="flex align-items-center gap-2">
          <span title={`${rowData[column.field]}`}>
            {rowData[column.field]}</span>
        </div>
      )}
      showFilterMatchModes={false}
      filter
      filterElement={(options) =>
        customFilterMenu(options, column.title, column.field)
      }
      style={{ minWidth: column.width}}
      className={styles.columCss}
      filterIcon={
        <i className="pi pi-filter" style={{ marginRight: '5px' }} />
      }
    />
  ));

  const header = renderHeader();
  console.log("...data.length: ", data.length);
  return (
    <div className="card">
      <div className={clsx(styles.scrollBarTable)}>
        <DataTable 
        // className={styles.customTable}
            ref={tableRef}
            scrollable
            scrollHeight={height === '' || height === null || height === undefined ? '250px' : height}
            // scrollHeight="250px"
            // scrollWidth="200px"
            //  style={{minWidth: '50rem', fontSize: "10px" }}
            // scrollHeight="flex" 
            // style={{ minWidth: '50rem' }}
            tableStyle={{minHeight:'270px', fontSize: '12px'}}
            className={clsx(styles.tableCss)}
            value={data}
            resizableColumns
            globalFilter={globalFilter}
            emptyMessage="No records found"
            filters={filters} 
            header={header}
            // filterDisplay="menu" 
            onFilter={(e) => setFilters(e.filters)}
            size={'small'}
            paginator
            // paginatorClassName="customPaginator"
            // rows={10} 
            rows={window.screen.height > 800 ? 20 : 10}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[10, 25, 50]}
            // loading={loading}
        >
        {dynamicColumns}
      </DataTable>
    </div>
    </div>
  );
};

ReportTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  ),
  columns: PropTypes.arrayOf(),
  height: PropTypes.string,
  fileName: PropTypes.string,
};

export default ReportTable;